import { css } from '@landr/styled-system/css';

const backgroundImageStyles = css({
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    objectFit: 'cover',
    objectPosition: 'center center',
    height: '100%',
    width: '100%',
});

const backgroundSkeletonStyles = css({
    position: 'absolute',
    width: '100%',
    height: '100%',
});

export const styles = {
    backgroundImage: backgroundImageStyles,
    backgroundSkeleton: backgroundSkeletonStyles,
};
